/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const SearchListBox = styled.ul`
  height: calc(100% - 53px);
  margin: 4px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

export const ItemBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 4px;
  width: 100%;
  height: 100%;
`;

export const TitleBox = styled.div`
  overflow: hidden;
`;

export const Title = styled.div`
  color: ${Palette.PrimaryGray._700};
`;

export const SmallText = styled.div`
  font-size: 12px !important;
  line-height: 16px !important;
  color: ${Palette.PrimaryGray._500};
`;

export const DarkerText = styled.div`
  display: inline;
  color: ${Palette.PrimaryGray._700};
`;
